<template>
    <div>
        <o-notification type="is-dark" has-icon>Drag and drop items between lists</o-notification>
        <div class="columns">
            <div class="column is-6">
                <div class="panel-block">
                    <p class="control">
                        <input class="input is-small" type="text" placeholder="search" v-model="availableFilter">
                    </p>
                </div>
              <draggable
                  :model-value="services"
                  item-key="id"
                  group="people"
                  @change="$event => restoreSelected($event)"
                  style="min-height: 100%"
              >
                <template #item="{ element, index }">
                  <div :class="['panel-block', 'is-active', {'is-hidden': isAvailableServiceHidden(element, availableFilter) }]"
                  >{{ element.title }}</div>
                </template>
              </draggable>
            </div>
            <div class="column is-6">
                <div class="panel-block">
                    <p class="control">
                        <input class="input is-small" type="text" placeholder="search" v-model="selectedFilter">
                    </p>
                </div>
              <draggable
                  :model-value="selectedServices"
                  item-key="id"
                  group="people"
                  @change="$event => addSelected($event, services)"
                  style="min-height: 100%"
              >
                <template #item="{ element, index }">
                    <a
                        :class="['panel-block', 'is-active', {'is-hidden': isSelectedServiceHidden(element, selectedFilter) }]"
                        v-if="element.type === 'optional'"
                    >{{ element.title }}
                    </a>
                </template>
              </draggable>
            </div>
        </div>
    </div>
</template>

<script>
    import ProjectServices from '../mixins/ProjectServices'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [ProjectServices],


        data () {
            return {
                type: 'optional',
                item: [],
            }
        },

        computed: {
            ...mapGetters(['optionalServices']),


          services: {
                get () {
                    return this.optionalServices
                },
                set () {}
            },

          selected: {
            get () {
              return this.projectServicesBySource({
                source_type: this.sourceType,
                source_id: this.sourceId
              })
            },
            set () {
            }
          }
        },

      methods: {
        ...mapActions(['removeEditingProjectService', 'removeProjectService2']),

        removeService(projectService) {
          // if (typeof projectService.id === 'string' && projectService.id.includes('s')) {
          //   this.removeEditingProjectService(projectService)
          // } else {
          //   this.removeProjectService2(projectService)
          // }
          this.$store.state.projectServices.items = this.$store.state.projectServices.items.filter(item => item.id !== projectService.id);

        }
        }
    }
</script>
